export enum GlType {
	ADJACENT_POINTS_ATTRIB_SMOOTH = 'adjacentPointsAttribSmooth',
	ADJACENT_UV_ATTRIB_SMOOTH = 'adjacentUvAttribSmooth',
	ATTRIBUTE = 'attribute',
	COMPUTE_NORMALS = 'computeNormals',
	CONSTANT = 'constant',
	FOR_LOOP = 'forLoop',
	IF_THEN = 'ifThen',
	GLOBALS = 'globals',
	NOISE = 'noise',
	OUTPUT = 'output',
	PARAM = 'param',
	RAMP = 'ramp',
	// SDF
	SDF_2D_BOX = 'SDF2DBox',
	SDF_2D_CIRCLE = 'SDF2DCircle',
	SDF_2D_CROSS = 'SDF2DCross',
	SDF_2D_HEART = 'SDF2DHeart',
	SDF_2D_ROUNDED_X = 'SDF2DRoundedX',
	SDF_2D_STAIRS = 'SDF2DStairs',
	SDF_BOX = 'SDFBox',
	SDF_BOX_FRAME = 'SDFBoxFrame',
	SDF_BOX_ROUND = 'SDFBoxRound',
	SDF_CAPSULE = 'SDFCapsule',
	SDF_CAPSULE_VERTICAL = 'SDFCapsuleVertical',
	SDF_CONE = 'SDFCone',
	SDF_CONE_ROUND = 'SDFConeRound',
	SDF_ELONGATE = 'SDFElongate',
	SDF_FRACTAL_MANDELBROT = 'SDFFractalMandelbrot',
	SDF_GRADIENT = 'SDFGradient',
	SDF_HEXAGONAL_PRISM = 'SDFHexagonalPrism',
	SDF_HORSE_SHOE = 'SDFHorseShoe',
	SDF_LINK = 'SDFLink',
	SDF_OCTAHEDRON = 'SDFOctahedron',
	SDF_OCTOGONAL_PRISM = 'SDFOctogonalPrism',
	SDF_ONION = 'SDFOnion',
	SDF_PLANE = 'SDFPlane',
	SDF_PYRAMID = 'SDFPyramid',
	SDF_QUAD = 'SDFQuad',
	SDF_REPEAT_POLAR = 'SDFRepeatPolar',
	SDF_REVOLUTION = 'SDFRevolution',
	SDF_RHOMBUS = 'SDFRhombus',
	SDF_RHOMBUS_TRIACONTAHEDRON = 'SDFRhombusTriacontahedron',
	SDF_SOLID_ANGLE = 'SDFSolidAngle',
	SDF_SPHERE = 'SDFSphere',
	SDF_SPHERE_CUT = 'SDFSphereCut',
	SDF_SPHERE_HOLLOW = 'SDFSphereHollow',
	SDF_TORUS = 'SDFTorus',
	SDF_TRANSFORM = 'SDFTransform',
	SDF_TRIANGULAR_PRISM = 'SDFTriangularPrism',
	SDF_TRIANGLE = 'SDFTriangle',
	SDF_TUBE = 'SDFTube',
	SDF_TWIST = 'SDFTwist',
	SDF_CONTEXT = 'SDFContext',
	SDF_MATERIAL = 'SDFMaterial',
	//
	TEXTURE = 'texture',
	TEXTURE_DISPLACEMENT = 'textureDisplacement',
	TEXTURE_SDF = 'textureSDF',
	VARYING_READ = 'varyingRead',
	VARYING_WRITE = 'varyingWrite',
	VERTEX_ANIMATION_TEXTURE = 'vertexAnimationTexture',
	VERTEX_ANIMATION_TEXTURE_INTERPOLATED = 'vertexAnimationTextureInterpolated',
}
